import LegalPage from '../components/ui/LegalPage.jsx'

export default function Dmca() {
  return (
    <LegalPage
      title="DMCA Policy"
      description="FastAudio DMCA Policy — how to submit a copyright takedown notice and what information is required for a valid DMCA request."
      slug="dmca"
      lastUpdated="January 2025"
    >
      <p>
        FastAudio respects the intellectual property rights of others and complies with the
        Digital Millennium Copyright Act (DMCA). If you believe that content accessible
        through our service infringes your copyright, please submit a written notice to us.
      </p>

      <h2 className="text-foreground font-semibold text-base mt-6 mb-2">What FastAudio Does</h2>
      <p>
        FastAudio does not host, cache, or distribute third-party media. The service acts as
        a conversion tool that processes publicly accessible URLs at the user's request.
        We do not store converted files beyond a short temporary window.
      </p>

      <h2 className="text-foreground font-semibold text-base mt-6 mb-2">Submitting a DMCA Notice</h2>
      <p>A valid DMCA takedown notice must include:</p>
      <ul className="list-disc list-inside space-y-1 ml-2">
        <li>Your name and contact information (address, phone, email)</li>
        <li>A description of the copyrighted work you claim has been infringed</li>
        <li>The URL or description of the material you claim is infringing</li>
        <li>A statement that you have a good-faith belief the use is not authorised</li>
        <li>A statement that the information is accurate and, under penalty of perjury,
            that you are the copyright owner or authorised to act on their behalf</li>
        <li>Your physical or electronic signature</li>
      </ul>

      <h2 className="text-foreground font-semibold text-base mt-6 mb-2">Send Notices To</h2>
      <p>
        Email:{' '}
        <a href="mailto:dmca@fastaudio.cc" className="text-primary hover:underline">
          dmca@fastaudio.cc
        </a>
      </p>

      <p className="mt-6 pt-4 border-t border-border/50 text-xs">
        For the current version of this policy, visit{' '}
        <a href="https://fastaudio.cc/dmca" className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">
          fastaudio.cc/dmca
        </a>.
      </p>
    </LegalPage>
  )
}
